export * from './agris-cotiz-detalle-renovar-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-renovar-dialog/index.ts